<mat-checkbox style="width: 100%;" class="mat-option" color="primary" [indeterminate]="isIndeterminate()" [checked]="isChecked()" (click)="$event.stopPropagation()"
    (change)="toggleSelection($event)">
    {{ 'gateway.label.select_all' | translate }}
</mat-checkbox>